import { useEffect, useRef } from "react";
import { loadMicroapps } from "./OpenBoxCard";

export const MutiModal = (props) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const app = loadMicroapps("@microapps/double-invite-retail", "./Share")
      .then(({ shareMutiModal }) => {
        return shareMutiModal.mount(ref.current);
      })
      .then((shareMutiModal) => {
        shareMutiModal.setProps({ isLogin: true });
      });
  }, []);
  return <div ref={ref}></div>;
};
